import { render, staticRenderFns } from "./EpDangerTypeReport.vue?vue&type=template&id=fdbdf27c&scoped=true&"
import script from "./EpDangerTypeReport.vue?vue&type=script&lang=js&"
export * from "./EpDangerTypeReport.vue?vue&type=script&lang=js&"
import style0 from "./EpDangerTypeReport.vue?vue&type=style&index=0&id=fdbdf27c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbdf27c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdbdf27c')) {
      api.createRecord('fdbdf27c', component.options)
    } else {
      api.reload('fdbdf27c', component.options)
    }
    module.hot.accept("./EpDangerTypeReport.vue?vue&type=template&id=fdbdf27c&scoped=true&", function () {
      api.rerender('fdbdf27c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/epreport/EpDangerTypeReport.vue"
export default component.exports